import PropTypes from "prop-types";
import React from "react";

import { createClassNameString } from "@/utils/createClassNameString";

import "./styles.scss";

export const NotificationSection = ({ children, className, status, ...props }) => (
  <div
    className={createClassNameString(["apti-CL apti-NotificationSection", className, status])}
    {...props}
  >
    {children}
  </div>
);

NotificationSection.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  status: PropTypes.string,
};

NotificationSection.defaultProps = {
  children: <></>,
  className: undefined,
  status: undefined,
};
